module.exports = __webpack_public_path__ + "static/media/mypayslips.f9c67fa9.png";